import React, { useEffect, useMemo, useState } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ColorPricingAddEdit from "./colorPricingCategoryAddEdit";
import ColorPricingCategoryTable from "./colorPricingCategoryTable";

function ColorPricingCategoryContainer(props) {
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route path={`${path}/edit/:id`}>
          <ColorPricingAddEdit />
        </Route>
        <Route path={`${path}/add`}>
          <ColorPricingAddEdit />
        </Route>
        <Route path={`${path}`}>
          <ColorPricingCategoryTable />
        </Route>
      </Switch>
    </>
  );
}

export default ColorPricingCategoryContainer;

